export const IDR = (amount) =>
  "Rp " + Number(amount || 0).toLocaleString("id-ID", { maximumFractionDigits: 0 });

export const USD = (amount) =>
  "$" + Number(amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const shortDate = (iso) => (iso ? String(iso).slice(0, 10) : "—");

export const dateTime = (iso) => (iso ? String(iso).slice(0, 16).replace("T", " ") : "—");
